class jfEffectivePermissionController {
    constructor($stateParams, $scope, BuildsDao, JFrogEventBus, JFrogTableViewOptions, $state,
            commonGridColumns, User, $window, AppContext) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.user = User.getCurrent();
        this.commonGridColumns = commonGridColumns;
        this.buildsDao = BuildsDao;
        this.historyData = null;
        this.JFrogEventBus = JFrogEventBus;
        this.$scope = $scope;
        this.$window = $window;
        this.AppContext = AppContext;
        this.cellTemplateGenerators = JFrogTableViewOptions.cellTemplateGenerators;
        this.nameCellTemplate = require('../../../common_templates/jf_effective_permission.name.template.html');

        this._getData();

        this.JFrogEventBus.registerOnScope(this.$scope, this.JFrogEventBus.getEventsDefinition().BUILDS_TAB_REFRESH, () => {
            this._getData();
        });

        // Users Table
        this.usersEffectivePermissionsOptions = {};
        this.usersEffectivePermissionsOptions = new JFrogTableViewOptions(this.$scope);
        this.usersEffectivePermissionsOptions.setId('users-effective-permission-table')
            .setObjectName('User')
            .setColumns(this.getColumns('users'));

        // Groups Table
        this.groupsEffectivePermissionsOptions = {};
        this.groupsEffectivePermissionsOptions = new JFrogTableViewOptions(this.$scope);
        this.groupsEffectivePermissionsOptions.setId('groups-effective-permission-table')
            .setObjectName('Group')
            .setColumns(this.getColumns('groups'));

        // Permission Targets Table
        this.permissionTargetsOptions = {};
        this.permissionTargetsOptions = new JFrogTableViewOptions(this.$scope);
        this.permissionTargetsOptions.setId('permission-targets-table')
                                    .setObjectName('Permission Target')
                                    .setColumns(this.getPermissionTargetsColumns());;
    }

    isCurrentUserAdmin() {
        return this.user.isAdmin();
    }

    _getData() {
        this.buildsDao.buildEffectivePermission({},{
            name: this.$stateParams.buildName,
            buildNumber: this.$stateParams.buildNumber,
            startTime: this.$stateParams.startTime
        }).$promise.then(response => {
            this.userEffectivePermissions = response.userEffectivePermissions;
            this.groupEffectivePermissions = response.groupEffectivePermissions;
            this.permissionTargets = response.permissionTargets;

            this.usersEffectivePermissionsOptions.setData(this.userEffectivePermissions);
            this.groupsEffectivePermissionsOptions.setData(this.groupEffectivePermissions);
            this.permissionTargetsOptions.setData(this.permissionTargets);
        });
    }

    goToEditPrincipal(tableType, row){
        // If admin - go to edit page of selected principal
        let principal = {};
        const stateName = `admin.security.edit${tableType === 'users' ? 'User' : 'Group'}`;
        let principalName = (tableType === 'users' ? 'username' : 'groupname');
        principal[principalName] = row.principal;
        this.$state.go(stateName, principal)
    }

    getColumns(type) {
        return [
            {
                header: 'Principal',
                field: 'principal',
                filterable: true,
                cellTemplate:
                    `<div class="ui-grid-cell-contents">
                        <i jf-tooltip="Admin Privileges"
                           class="icon pull-left"
                           ng-class="row.entity.admin ? 'icon-admin-new' : 'icon-blank'"></i>
                        <a href 
                           ng-if="grid.appScope.$ctrl.isCurrentUserAdmin()"
                           class="jf-link"
                           ng-click="grid.appScope.$ctrl.goToEditPrincipal('${type}',row.entity)">
                            {{row.entity.principal}}
                        </a>
                        <span ng-if="!grid.appScope.$ctrl.isCurrentUserAdmin()">
                            {{{row.entity.principal}}
                        </span>
                    </div>`,
                width: '30%'
            },
            {
                header: 'Permission Target',
                field: 'permissionTarget',
                width: '30%',
                cellTemplate: this.cellTemplateGenerators.listableColumn('row.entity.permissionTargets','row.entity.principal'),
            },
            {
                header: 'Read',
                field: 'permission.read',
                textAlign: 'center',
                cellTemplate: this.commonGridColumns.booleanColumn('MODEL_COL_FIELD')
            },
            {
                header: 'Annotate',
                field: 'permission.annotate',
                textAlign: 'center',
                cellTemplate: this.commonGridColumns.booleanColumn('MODEL_COL_FIELD')
            },
            {
                header: 'Deploy',
                field: 'permission.deploy',
                textAlign: 'center',
                cellTemplate: this.commonGridColumns.booleanColumn('MODEL_COL_FIELD')
            },
            {
                header: 'Delete',
                textAlign: 'center',
                field: "permission.delete",
                cellTemplate: this.commonGridColumns.booleanColumn('MODEL_COL_FIELD')
            },
            {
                header: "Manage Xray Meta",
                textAlign: 'center',
                field: "permission.managedXrayMeta",
                cellTemplate: this.commonGridColumns.booleanColumn('MODEL_COL_FIELD'),
                width: '12%',
                isVisible: () => this.AppContext.hasXray() && this.AppContext.hasXrayLicense()
            },
            {
                header: "Manage Watches",
                textAlign: 'center',
                field: "permission.managedXrayWatches",
                cellTemplate: this.commonGridColumns.booleanColumn('MODEL_COL_FIELD'),
                width: '10%',
                isVisible: () => this.AppContext.hasXray() && this.AppContext.hasXrayLicense()
            }
        ]
    }

    getPermissionTargetsColumns() {
        return [
            {
                header: 'Permission Target Name',
                field: 'permissionName',
                filterable: true,
                cellTemplate: this.nameCellTemplate,
                width: '30%'
            },
            {
                header: 'Users',
                field: 'users',
                cellTemplate: this.cellTemplateGenerators.listableColumn('row.entity.users','row.entity.permissionName')
            },
            {
                header: 'Groups',
                field: 'groups',
                cellTemplate: this.cellTemplateGenerators.listableColumn('row.entity.groups','row.entity.permissionName')
            }
        ]
    }

    onNameClick({permissionName}) {
        this.$window.$vueRouter.push({
            name: 'admin.management.permissions.edit',
            params: {permissionName}
        });
    }
}

export function jfEffectivePermission() {
    return {
        restrict: 'EA',
        controller: jfEffectivePermissionController,
        controllerAs: '$ctrl',
        scope: {},
        bindToController: true,
        templateUrl: 'states/builds/build_tabs/jf_effective_permission.html'
    }
}



// WEBPACK FOOTER //
// ./states/builds/build_tabs/jf_effective_permission.js